export default __webpack_public_path__ + "static/media/2_D.bf0e47fe.svg";